/**
 * @generated SignedSource<<9c6e24f735b741c014d433395a19e66b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SyncMemberTagsPayload",
    "kind": "LinkedField",
    "name": "syncMemberTags",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "membersFound",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "threadsUpdated",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Error",
        "kind": "LinkedField",
        "name": "error",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "InboxQuery_SyncMemberTagsMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "InboxQuery_SyncMemberTagsMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "013b9c6f794b847b5719b8156626cc6b",
    "id": null,
    "metadata": {},
    "name": "InboxQuery_SyncMemberTagsMutation",
    "operationKind": "mutation",
    "text": "mutation InboxQuery_SyncMemberTagsMutation(\n  $input: SyncMemberTagsInput!\n) {\n  syncMemberTags(input: $input) {\n    ok\n    membersFound\n    threadsUpdated\n    error {\n      message\n    }\n  }\n}\n"
  }
};
})();

node.hash = "6dc0a08338ccd997c8275cbe8fb913d0";

module.exports = node;
